import React from "react";

import { ButtonProps } from "@mui/material";
import classnames from "classnames";

import Button, { Color } from "../../Form/Button";
import MenuActionsButton, { MenuActionsButtonItems } from "../MenuActionsButton";
import useStyles from "./styles";

export interface GroupButtons extends ButtonProps {
  dataCy?: string;
  action?: () => void;
  customColor?: Color;
  name: string;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  text?: string;
  menuItems?: MenuActionsButtonItems[];
  ghost?: boolean;
  variant?: "text" | "outlined" | "contained" | undefined;
  children?: JSX.Element;
}
export interface GroupedButtonsProps {
  buttons?: GroupButtons[];
}

export const GroupedButtons: React.FC<GroupedButtonsProps> = ({ buttons }) => {
  const classes = useStyles();

  const renderButton = (button: GroupButtons) => {
    if (button?.menuItems) {
      return (
        <MenuActionsButton
          key={button.name}
          menuItems={button?.menuItems || []}
          loading={!!button?.loading}
          viewOnly={button?.disabled}
        />
      );
    }
    if (button?.action) {
      return (
        <Button
          key={button.name}
          ghost={button?.ghost}
          variant={button?.variant}
          data-cy={button?.dataCy || `button-${button.name}`}
          onClick={button?.action}
          customColor={button?.customColor}
          disabled={button?.disabled}
          loading={button?.loading}
          className={classnames(classes.rightButton, button?.className)}
          startIcon={button?.startIcon}
        >
          {button?.children || button?.text || button.name}
        </Button>
      );
    }
  };

  const renderButtons = () => {
    if (buttons) return buttons.map((button) => renderButton(button));
  };

  return <>{renderButtons()}</>;
};
